import { generatePath } from "react-router-dom";

/** The Bid Package details page, as routed in App.tsx. */
export const BID_PACKAGE_DETAILS_ROUTE =
  "/project/:projectId/bid-packages/:bidPackageId";

export function bidPackageDetailsPath(
  projectId: string,
  bidPackageId: string
): string {
  return generatePath(BID_PACKAGE_DETAILS_ROUTE, { projectId, bidPackageId });
}
